
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/focused-map-shape",
      function () {
        return require("private-next-pages/x/api/charts/focused-map-shape.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/focused-map-shape"])
      });
    }
  